export default __webpack_public_path__ + "static/media/icone-Busca-Ativa.f85439e4.svg";